import { render, staticRenderFns } from "./GoalDisplay.vue?vue&type=template&id=d2d96516&"
import script from "./GoalDisplay.vue?vue&type=script&lang=js&"
export * from "./GoalDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GoalDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports